import * as React from "react";
var ServerError = function ServerError() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "\u7F16\u7EC4 12"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-24.6%",
    y: "-25.6%",
    width: "155.4%",
    height: "157.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-serverError"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.835294118 0 0 0 0 0.882352941 0 0 0 0 0.988235294 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.164 69.927a5.429 5.429 0 015.429 5.428v17.541a5.429 5.429 0 01-5.429 5.429H21.612a5.429 5.429 0 01-5.428-5.429v-17.54a5.429 5.429 0 015.428-5.43h86.552zm0-32.673a5.429 5.429 0 015.429 5.428v17.541a5.429 5.429 0 01-5.429 5.429H21.612a5.429 5.429 0 01-5.428-5.429v-17.54a5.429 5.429 0 015.428-5.43h86.552zm0-32.674a5.429 5.429 0 015.429 5.429V27.55a5.429 5.429 0 01-5.429 5.429H21.612a5.429 5.429 0 01-5.428-5.429V10.009a5.429 5.429 0 015.428-5.429h86.552z",
    id: "path-serverError"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .585h160v160H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.271 35.987)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E9EEF7",
    x: 25.039,
    width: 79.698,
    height: 103.516,
    rx: 5.429
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.937 55.06l55.406-15.83a5.429 5.429 0 016.92 5.22v53.638a5.429 5.429 0 01-5.43 5.428H5.43A5.429 5.429 0 010 98.088V60.28a5.429 5.429 0 013.937-5.22z",
    fill: "#E9EEF7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFF0F2",
    d: "M26.566 16.795h76.645v78.171H26.566z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#filter-serverError)",
    xlinkHref: "#path-serverError"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#path-serverError"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.413 14.521)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E9EEF7",
    strokeWidth: 2.714,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.153.237v10.179M7.481.237v10.179M14.81.237v10.179M22.138.237v10.179"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDD5E2",
    cx: 73.896,
    cy: 5.174,
    r: 4.122
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.413 46.279)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E9EEF7",
    strokeWidth: 2.714,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.153.237v10.179M7.481.237v10.179M14.81.237v10.179M22.138.237v10.179"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDD5E2",
    cx: 73.896,
    cy: 5.174,
    r: 4.122
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.26 79.715)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#E9EEF7",
    strokeWidth: 2.714,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.153.237v10.179M7.481.237v10.179M14.81.237v10.179M22.138.237v10.179"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDD5E2",
    cx: 73.896,
    cy: 5.174,
    r: 4.122
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M38.977 25.9l12.068 20.492a2.138 2.138 0 01-1.843 3.224H25.067a2.138 2.138 0 01-1.843-3.224L35.292 25.9a2.138 2.138 0 013.685 0z",
    fill: "#B6C2D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.927 33.907c0-.631.53-1.144 1.187-1.144s1.188.513 1.188 1.144v6.583c0 .63-.531 1.143-1.188 1.143-.657 0-1.187-.512-1.187-1.143v-6.583zM38.231 45.888c-.282.282-.68.447-1.08.447-.399 0-.796-.165-1.079-.447a1.546 1.546 0 01-.447-1.08c0-.4.165-.797.447-1.08.283-.282.68-.447 1.08-.447s.797.165 1.08.447c.282.283.447.68.447 1.08s-.165.797-.448 1.08z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
};
export default ServerError;